import { useMemo } from 'react';
import PickerButton from '../PickerButton';
export default function useComponents(components) {
    return useMemo(() => ({
        ...components,
        okButton: components?.okButton ?? components?.button ?? PickerButton,
    }), [components]);
}
